<form [formGroup]="form">
  <div *ngIf="protocol" class="card-inline">
    <h3>Protocolo: {{ protocol }}</h3>
  </div>
  <mat-divider></mat-divider>
  <mat-spinner *ngIf="loading" matSuffix></mat-spinner>
  <div *ngIf="!loading" class="full-width">
    <div *ngIf="printTicket" class="margin-top-medium full-width">
      <h4>Etiqueta</h4>
      <mat-divider></mat-divider>
      <div class="margin-top-medium margin-right-small full-width">
        <mat-form-field class="full-width">
          <mat-label>Cantidad de copias</mat-label>
          <input
            type="number"
            formControlName="TicketQuantity"
            min="1"
            matInput
            required
          />
          <button (click)="printTicketReport()" matSuffix mat-mini-fab>
            <mat-icon>print</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="printMedicalOrderTicket" class="margin-top-medium full-width">
      <h4>Orden de retiro</h4>
      <mat-divider></mat-divider>
      <div class="margin-top-medium full-width">
        <mat-form-field class="full-width">
          <mat-label>Cantidad de copias</mat-label>
          <input
            type="number"
            formControlName="MedicalOrderTicketQuantity"
            min="1"
            matInput
            required
          />
          <button (click)="printOrderReport()" matSuffix mat-mini-fab>
            <mat-icon>print</mat-icon>
          </button>

          <button
            *ngIf="canSendOrderWhatsapp"
            (click)="registerPatientMessage()"
            matSuffix
            mat-mini-fab
          >
            <mat-icon svgIcon="ws"></mat-icon>
          </button>

          <button (click)="sendMailOrderReport()" matSuffix mat-mini-fab>
            <mat-icon>mail</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="printConsent" class="margin-top-medium full-width">
      <h4>Consentimiento</h4>
      <mat-divider></mat-divider>
      <div class="margin-top-medium full-width">
        <mat-form-field class="full-width">
          <mat-label>Cantidad de copias</mat-label>
          <input
            type="number"
            formControlName="ConsentQuantity"
            min="1"
            matInput
            required
          />
          <button (click)="printConsentReport()" matSuffix mat-mini-fab>
            <mat-icon>print</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="printQuestionnaire" class="margin-top-medium full-width">
      <h4>Cuestionario historia clínica</h4>
      <mat-divider></mat-divider>
      <div class="margin-top-medium full-width">
        <mat-form-field class="full-width">
          <mat-label>Cantidad de copias</mat-label>
          <input
            type="number"
            formControlName="QuestionnaireQuantity"
            min="1"
            matInput
            required
          />
          <button (click)="printQuestionnaireReport()" matSuffix mat-mini-fab>
            <mat-icon>print</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <div class="margin-top-medium full-width">
      <h4>Mail recordatorio</h4>
      <mat-divider></mat-divider>
      <div class="margin-top-medium full-width">
        <mat-form-field class="full-width">
          <mat-label>Cantidad</mat-label>
          <input
            type="number"
            value="1"
            min="1"
            matInput
            required
            readonly
          />
          <button (click)="sendMail()" matSuffix mat-mini-fab>
            <mat-icon>mail_outline</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <div class="margin-top-medium full-width">
      <h4>Fecha entrega informe/resultados</h4>
      <mat-divider></mat-divider>
      <div class="margin-top-medium full-width">
        <mat-form-field class="full-width">
          <mat-label>Fecha</mat-label>
          <input
            type="text"
            formControlName="DeliveryDate"
            matInput
            readonly
          />
          <button (click)="refreshDeliveryDate()" matSuffix mat-mini-fab>
            <mat-icon>refresh</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
